export default __webpack_public_path__ + "static/media/lendnest2.d87177cf.png";